export function getMaxLengthValidation(maxLength: number) {
  return (value: string | null | undefined) => {
    if (value && value.length > maxLength) {
      return `Maximum length is ${maxLength} characters.`;
    }
    return undefined;
  };
}
